import pt_BR from 'ant-design-vue/es/locale/pt_BR';

const messages = {
  summary: {
    title: 'Seu pedido está:',
    promoted: 'Atualizado {date}.',
    finished: 'Finalizado {date}.',
  },
  events: {
    title: 'Rastrear sua entrega',
  },
  status: {
    CREATED: {
      title: 'Em Preparação',
      subtitle: 'Seu pedido está sendo preparado pelo vendedor.'
    },
    PREPARED: {
      title: 'Pronto para Envio',
      subtitle: 'Seu pedido foi preparado e está pronto para ser enviado.'
    },
    IN_TRANSIT: {
      title: 'Nas Mãos do Mensageiro',
      subtitle: 'Seu pedido foi enviado pelo vendedor.'
    },
    ON_THE_WAY: {
      title: 'A Caminho!',
      subtitle: 'Seu pedido está a caminho do seu endereço.'
    },
    FAILED: {
      title: 'Entrega Não Realizada',
      subtitle: 'Seu pedido ainda não pôde ser entregue.'
    },
    DELIVERED: {
      title: 'Entregue!',
      subtitle: 'Seu pedido foi entregue no seu endereço.'
    },
    RETURNED: {
      title: 'Retornado!',
      subtitle: 'Seu pedido foi retornado ao vendedor.'
    },
    CANCELED: {
      title: 'Cancelado',
      subtitle: 'Seu pedido foi cancelado.'
    }
  }
}

export default {
  locale: 'pt-BR',
  antd: pt_BR,
  messages,
}
